/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { Body } from '@highlight-ui/typography';

import styles from './EmptyState.module.scss';

export type DefaultEmptyStateProps = {
  /** Label for displaying the empty state of the Select list */
  label: string;
  /** No search results message */
  searchNoResultsLabel?: string;
  /** Custom empty options list component - Used because of old Select component */
  customComponent?: (() => React.ReactNode) | undefined;
};

export const DefaultEmptyState = ({
  label,
  searchNoResultsLabel,
}: DefaultEmptyStateProps) => (
  <div
    className={
      searchNoResultsLabel ? styles.noResults : styles.defaultEmptyState
    }
  >
    <Body color="text-default">
      {searchNoResultsLabel ? `${searchNoResultsLabel} "${label}"` : label}
    </Body>
  </div>
);
